import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const Text = styled.p`
  font-size: 16px;
  padding: 5px 0;
  line-height: 150%;
  ${({ isSmall }) =>
    isSmall &&
    css`
      font-size: 15px;
    `};
  ${({ isLarge }) =>
    isLarge &&
    css`
      font-size: 19px;
    `};
  ${({ isSecondary }) =>
    isSecondary &&
    css`
      color: ${({ theme }) => theme.defaultColors.fontSecondary};
    `};
`;

export const HelperText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const UnorderedList = styled.ul`
  padding: 8px 0 8px 40px;
  li + li {
    margin-top: 10px;
  }
`;

export const EyebrowTitle = styled.h6`
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  text-transform: uppercase;
  opacity: 1;
  margin: 0;
`;

export const ProductTitle = styled.h2`
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  opacity: 1;

  ${media.md`
    font-size: ${({ isLarge }) => (isLarge ? 18 : 16)}px;
  `}
`;

export const BodySmallMuted = styled.div`
  font-size: 15px;
  padding-top: 5px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-weight: normal;
`;

export const PageTitle = styled.h2`
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.sectionTitleColour};
  font-family: ${({ theme }) => theme.headerFont};
  font-size: 28px;
  line-height: 42px;
  font-weight: ${({ theme }) => theme.fontWeights.normal};

  ${media.md`
    font-size: 32px;
  `}
`;
